import { BrokenImage, Photo, Video } from '@travel/icons/ui';
import { Translate } from '@travel/translation';

import { MediaStatus } from 'store/apiTypes';

export const ACCEPTED_IMAGE_FILE_EXTENSIONS_FOR_UPLOAD: string[] = [
  '.jpg',
  '.jpeg',
  '.png',
  'image/jpeg',
  'image/jpg',
  'image/png',
] as const;

export const ACCEPTED_VIDEO_FILE_EXTENSIONS_FOR_UPLOAD: string[] = [
  '.mp4',
  '.mov',
  'video/mp4',
  'video/quicktime',
] as const;

export const IMAGE_UPLOAD_ERROR_MESSAGES = {
  INVALID_FILE_TYPE: <Translate id="MyReview.Edit.Image.Validation.FileType" />,
  FILE_TOO_LARGE: <Translate id="MyReview.Edit.Image.Validation" />,
} as const;

export const IMAGE_UPLOADER_OPTIONS = {
  selectPhoto: {
    id: 'select_photo',
    label: <Translate id="MyReview.Edit.Modal.SelectLibrary" />,
  },
  takePhoto: {
    id: 'take_photo',
    label: <Translate id="MyReview.Edit.Modal.TakePhoto" />,
  },
  removePhoto: {
    id: 'remove',
    label: <Translate id="MyReview.Edit.Modal.DeletePhoto" />,
  },
} as const;

export const MEDIA_ICONS = {
  [MediaStatus.OK]: Photo,
  [MediaStatus.PROCESSING]: Video,
  [MediaStatus.NOT_FOUND]: BrokenImage,
} as const;

export const MEDIA_LIST_SIZE = 30;
export const MEDIA_GALLERY_LIMIT = 30;
export const MAX_SIZE_MB = 20;
export const MEDIA_CLEANUP_TIMEOUT = 30000;
export const MEDIA_UPLOAD_TIMEOUT = 30 * 60 * 1000;
export const LAZY_LOAD_IMAGE_COUNT_PC = 4;
export const LAZY_LOAD_IMAGE_COUNT_SP = 2;
export const MEDIA_ENABLE_VIDEO = true;
